import React from "react";
import "./manet_legacy.css";

const ManetLegacy = () => {
  const cards = [
    {
      img: "/assets/images/icons/crown.webp",
      title: "A1",
      subtitle: "CIP Grade Outstanding",
      link: "https://www.manetpune.edu.in/assets_web/pdf/CIP_INSPECTION_CERTIFICATE-2024.pdf"
    },
    {
      img: "/assets/images/icons/calendar.webp",
      title: "25",
      subtitle: "Glorious Years",
      link: "/aboutus/about-manet"
    },
        {
      img: "/assets/images/icons/suitcase.webp",
      title: "100%",
      subtitle: "Placement Assistance",
      link: "/placement/placement-cell"
    },
    {
      img: "/assets/images/icons/people.webp",
      title: "30+",
      subtitle: "Recruiters On Board",
      link: "/placement/top-recruiters"
    },

    {
      img: "/assets/images/icons/students.webp",
      title: "3500+",
      subtitle: "Benefited Alumni",
      link: ""
    },
  ];

  return (
    <>
      <div className="legacy">
        <h1 className="title">25 Years Of Legacy In Maritime Education</h1>
        <h2 className="subtitle">A Institute Of Life Transformation</h2>

        <div className="legacy-container">
          {cards.map((card, index) => (

            <div className="legacy-card" key={index}

              onClick={() => {
                if (card.link) {
                  window.open(card.link, "_blank");
                }
              }}
              style={{ cursor: card.link ? "pointer" : "default" }}  >
                
              <div className="legacy-icon">
                <div className="circle-border"></div>
                <div className="circle-content">
                  <img src={card.img} alt={card.title} />
                  <span className="title" id="legacy-title">{card.title}</span>
                </div>
              </div>

              {/* <h1 className="title" id="legacy-title">
                {card.title}
              </h1> */}
              <h2 className="legacy-subtitle">{card.subtitle}</h2>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default ManetLegacy;
